var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "job-detail job-detail--programator" }, [
      _c("div", { staticClass: "job-detail__heading" }, [
        _c("h2", [
          _vm._v(
            "\n            Jsi PHP vývojář/ka, kterého nebaví korporátní rutina a hledá smysluplnou práci na zajímavých projektech?\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "job-detail__subheading" }, [
        _c("div", { staticClass: "job-detail__subheading__spacer-block" }, [
          _c("div", {
            staticClass: "job-detail__subheading__spacer-block__line"
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "job-detail__subheading__text-block" }, [
          _c("p", [
            _vm._v(
              "Chceš pracovat v menším týmu lidí, kteří dělají to, co je baví? Pokud ano, pak se přidej k nám! Pracujeme na rozmanitých zakázkách, od webových aplikací, přes komplexní e-commerce řešení až po různorodé integrace a automatizace."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "job-detail__text" }, [
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("h3", [_vm._v("Koho hledáme?")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v("Máš základní znalost PHP (objektové programování) a SQL.")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Rozumíš si s HTML, CSS a JS.")]),
          _vm._v(" "),
          _c("li", [_vm._v("Jsi zodpovědný/á a je na tebe spolehnutí.")]),
          _vm._v(" "),
          _c("li", [_vm._v("Znalost Nuxt, Vue.js výhodou.")])
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("h3", [_vm._v("Co ti nabízíme?")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v("Zajímavé projekty s různorodými technologiemi.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Nemusíš se bát, že nebudeš vědět kudy kam. Budeš mít k ruce zkušeného programátora Roberta, který ti poradí a probere s tebou vše, co budeš potřebovat."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Nečekáme, že budeš vše vědět hned. Ze startu si zkusíš jednoduché úkoly a postupně dostaneš více dlouhodobých projektů, o které se budeš starat."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Komunikaci s klientem vždy zajistí projekťák, který ti bude k ruce."
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Možnost růst a učit se nové věci.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Práci na full-time, po domluvě možnost i 4denní pracovní týden."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Různorodá práce – žádné nekonečné ladění jednoho formuláře."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Možnost ovlivnit, jak budou naše projekty vypadat a fungovat."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Flexibilní pracovní dobu a po domluvě občasný home office.")
          ])
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("h3", [_vm._v("Co ti nabízíme?")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v("Na co se můžeš u nás ještě těšit?")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Firemní kulturu postavenou na otevřenosti, důvěře a férovém jednání."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Měsíční turnaje v různých sportech, neboť ve zdravém těle zdravý duch. 🕺"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Teambuildingové aktivity a neformální setkání.")]),
          _vm._v(" "),
          _c("li", [_vm._v("Vybavení, stravenky a káva je samozřejmostí.")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }